export const mutations = {
    set_purchasedVoices(state, voice) {
        state.purchasedVoices = [...state.purchasedVoices, ...[voice]];
        localStorage.setItem('purchasedVoices', JSON.stringify(state.purchasedVoices));
    },

    set_loadPanelConfiguredVoices(state, voices) {
        state.panelConfiguredVoices = [...voices];
    },

    set_expireVoice(state, id) {
        const removeExpiredVoice = state.purchasedVoices.filter(voice =>  voice.id !== id);

        state.purchasedVoices = [...removeExpiredVoice];
        localStorage.setItem('purchasedVoices', JSON.stringify(removeExpiredVoice));
    },

    set_panelMinimumTime(state, minimumTime) {
        state.panelMinimumTime = minimumTime;
    },
};
